import React, { useEffect, useState } from 'react';
import { HeroSlider } from './HeroSlider';
import { getHeroSlides } from '../services/api';

export const HeroSliderSection = () => {
  const [slides, setSlides] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const fetchSlides = async () => {
    try {
      const response = await getHeroSlides();
      setSlides(response.data);
    } catch (error) {
      console.error('Failed to fetch hero slides:', error);
    }
  };

  useEffect(() => {
    fetchSlides();
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!slides || slides.length === 0) return null;

  return (
    <section className="relative py-12 md:py-16 bg-black overflow-hidden">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-950/10 to-black pointer-events-none"></div>
      
      {/* Section Header */}
      <div className="container mx-auto px-4 mb-8">
        <div 
          className={`text-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 mb-2">
            Featured
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-green-500 mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Slider Content */}
      <div 
        className={`relative z-10 transition-all duration-1000 ease-out delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <HeroSlider slides={slides} />
      </div>
    </section>
  );
};
